<div class="d-flex flex-column h-100">
    <div class="d-flex w-100">
        <telxl-search
            [searchText]="searchText()"
            (searchTextChange)="searchChanged($event)"
            id="queue-directory-search"
            class="w-100"
        ></telxl-search>
    </div>
    @if (queue(); as queue) {
        <div class="mt-3 mb-2">Current Queue</div>
        <div [style.padding-right.px]="5">
            <ng-container
                [ngTemplateOutlet]="queuePanel"
                [ngTemplateOutletContext]="{ $implicit: queue }"
            />
        </div>
    }
    <div class="mt-2">All Queue</div>
    <div class="scroll-container h-100 mt-2">
        @if (filteredQueues().length > 0) {
            @for (queue of filteredQueues(); track queue.id) {
                <ng-container
                    [ngTemplateOutlet]="queuePanel"
                    [ngTemplateOutletContext]="{ $implicit: queue }"
                />
            }
        } @else {
            <div
                class="d-flex flex-column align-items-center justify-content-center h-100"
            >
                <i class="fa-thin fa-face-zipper text-primary"></i>
                <div class="font-xxl mt-4">No data!</div>
                <div class="mt-4">No queues were found.</div>
            </div>
        }
    </div>
</div>

<ng-template #queuePanel let-q>
    <telxl-panel bodyClass="card-body-sm" cardClass="mb-2" [hover]="true">
        <ng-template #cardBody>
            <div class="d-flex w-100">
                <telxl-avatar variant="queue" icon="fa-light fa-list-tree" />
                <div
                    class="d-flex align-items-center justify-content-between w-100"
                >
                    <div>{{ q.name }}</div>
                    <div>
                        <telxl-button
                            colour="light"
                            (buttonClick)="transferToQueue(q.id)"
                        >
                            {{
                                queueId() === q.id
                                    ? 'Release Back To Queue'
                                    : 'Transfer'
                            }}
                        </telxl-button>
                    </div>
                </div>
            </div>
        </ng-template>
    </telxl-panel>
</ng-template>
